<template>

    <ui-view class="view-boatman">

        <ui-heading title="Gebruikers" icon="fa-user-circle-o">
            <ui-button color="positive" icon="magicon-plus" route="user-add">Gebruiker toevoegen</ui-button>
            <ui-searchbar v-model="search"/>
        </ui-heading>

        <ui-table-panel
            clickable
            v-spinner="loading"
            :placeholder="users && !users.items.length"
            :total="$safe('users.totalCount')"
            :visible="paging.limit"
            @page="switchPage">
            <ui-table-header>
                <ui-th weight="3" field="username" v-model="sort">Gebruikersnaam</ui-th>
                <ui-th weight="3" field="email" v-model="sort">E-mail adres</ui-th>
                <ui-th weight="2" field="growerId" v-model="sort">Kweker</ui-th>
                <ui-th weight="2" field="shipId" v-model="sort">Schip</ui-th>
                <ui-th weight="2" field="phoneNumber" v-model="sort">Telefoonnummer</ui-th>
                <ui-th weight="1"/>
            </ui-table-header>
            <ui-tr v-for="user in $safe('users.items')" :key="user.id" click="edit">
                <td>{{ user.username }}</td>
                <td>{{ user.email }}</td>
                <td>{{ (user.grower || {}).name | empty }}</td>
                <td>{{ (user.ship || {}).name | empty }}</td>
                <td>{{ user.phoneNumber | empty }}</td>
                <td class="actions" @click.stop>
                    <ui-link
                        icon="magicon-edit"
                        v-tooltip="'Wijzigen'"
                        action="edit"
                        :to="{ name: 'user-edit', params: { id: user.id }}" />
                    <ui-link icon="magicon-trash" v-tooltip="'Verwijderen'" @click="deleteUser(user.id)" />
                </td>
            </ui-tr>
        </ui-table-panel>

    </ui-view>

</template>

<script>

import Vue from 'vue';
import Component from 'vue-class-component';

import pagingMixin from 'js-core/js/mixins/paging';
import createQuery from 'js-core/js/apollo/queries/createQuery';

import AllUsersQuery from 'gql/queries/Users/AllUsers.gql';

import UserMutations from 'app/mutations/UserMutations';

@Component({

    name: 'Users',
    mixins: [pagingMixin],
    apollo: {
        users: createQuery(AllUsersQuery, {

            variables(){

                return {
                    offset: this.paging.offset,
                    limit: this.paging.limit,
                    search: this.search,
                    sortField: this.sort.field,
                    sortDirection: this.sort.direction
                };
            }
        })
    }
})
export default class Users extends Vue
{
    loading = 0;

    search = this.$persist('search');
    sort = this.$persist('sort', {
        field: 'username',
        direction: 'ASC'
    });

    breadcrumb(){

        return 'Gebruikers';
    }

    async deleteUser(id) {

        const { result, overlay } = await this.$alert.delete('Weet je zeker dat je deze gebruiker wilt verwijderen?');
        if(!result) {
            return;
        }

        try {

            await UserMutations.delete(id);

            this.$toast.success('De gebruiker is succesvol verwijderd');
            this.$refetchQuery('users');
        }
        catch(e) {

            this.logger.error(`Something went wrong while deleting user ${id}:`, e);
            this.$toast.error('Er is iets fout gegaan tijdens het verwijderen van de gebruiker');
        }

        this.$overlay.close(overlay);
    }
}

</script>